<agr-summary-card
  [title]="title()"
  [actionTitle]="actionTitle()"
  [actionIcon]="actionIcon()"
  [canExpand]="canExpand()"
  [isExpanded]="isExpanded()"
  (actionClicked)="actionClicked.emit(undefined)"
  [actions]="actions()"
>
  <ng-container *ngIf="items !== undefined">
    <div class="flex--column summary-card-kpi-chart" *ngIf="summaryLabel !== undefined">
      <div
        class="text--gray text--small summary-card-kpi-chart__summaryLabel"
        data-test="summary-card-kpi-chart__summaryLabel"
      >
        {{ summaryLabel | translate }}
      </div>
      <div
        class="text--large summary-card-kpi-chart__summaryValue"
        data-test="summary-card-kpi-chart__summaryValue"
      >
        <span
          class="flex--child--none"
          *ngIf="getSummaryValue() !== getEmptyValue() && summaryUnit && prefixSummaryUnit"
          >{{ summaryUnit | translate }}</span
        >
        <span class="flex--child--none" *ngIf="!this.isNAN(summaryValue)">
          {{ getSummaryValue() }}
        </span>
        <span
          class="flex--child--none"
          *ngIf="getSummaryValue() !== getEmptyValue() && summaryUnit && !prefixSummaryUnit"
          >{{ summaryUnit | translate }}</span
        >
        <span
          class="flex--child--auto text--small summary-card-kpi-chart__benchmarkLabel"
          data-test="summary-card-kpi-summarySubLabel"
          [ngClass]="{
            isPositive:
              showBenchmarkDeviationColor &&
              ((getBenchmarkDeviationPercentage() >= 0 && !isLowerThanBenchmarkBetter) ||
                (getBenchmarkDeviationPercentage() < 0 && isLowerThanBenchmarkBetter)),
            isNegative:
              showBenchmarkDeviationColor &&
              ((getBenchmarkDeviationPercentage() < 0 && !isLowerThanBenchmarkBetter) ||
                (getBenchmarkDeviationPercentage() >= 0 && isLowerThanBenchmarkBetter)),
          }"
        >
          {{ getBenchmarkDeviationPercentageLabel() }}
          <ng-container *ngIf="getBenchmarkDeviationPercentage() >= 0">
            <mat-icon class="text--small">arrow_upward</mat-icon>
          </ng-container>
          <ng-container *ngIf="getBenchmarkDeviationPercentage() < 0">
            <mat-icon class="text--small">arrow_downward</mat-icon>
          </ng-container>
        </span>
      </div>
    </div>
    <div *ngFor="let item of displayedItems" data-test="summary-card-kpi-chart__items">
      <ng-container
        data-test="summary-card-kpi-chart__item"
        *ngTemplateOutlet="chartSummaryItem; context: { $implicit: item }"
      ></ng-container>
    </div>
  </ng-container>
  <!-- Legenda here -->
  <div *ngIf="benchmarkValue !== undefined && !this.isNAN(benchmarkValue)" class="legenda">
    <svg width="2" height="13" class="svg-margin">
      <path
        fill="none"
        class="highcharts-plot-line"
        stroke="#000"
        stroke-width="2"
        d="M 1 0 L 1 13"
      ></path>
    </svg>
    =
    <span
      class="flex--child--auto text--bold"
      *ngIf="getBenchmarkValue() !== getEmptyValue() && benchmarkUnit && prefixBenchmarkUnit"
      >{{ benchmarkUnit | translate }}</span
    >
    <span
      *ngIf="!this.isNAN(benchmarkValue)"
      class="flex--child--auto text--bold"
      data-test="summary-card-kpi-chart__benchmarkValue"
    >
      {{ getBenchmarkValue() }}
    </span>
    <span
      class="flex--child--auto text--bold"
      *ngIf="getBenchmarkValue() !== getEmptyValue() && benchmarkUnit && !prefixBenchmarkUnit"
      >{{ benchmarkUnit | translate }}</span
    >
    | {{ benchmarkAgendaLabel }}
  </div>
  <div class="expand-buttons screen-only" *ngIf="!!items && items.length > 4">
    <!-- show more/less buttons -->
    <button mat-flat-button (click)="showItems('more')" *ngIf="isCollapsed">
      <mat-icon>expand_more</mat-icon>{{ 'farmer-insights.show-more' | translate }}
    </button>
    <button mat-flat-button (click)="showItems('less')" *ngIf="!isCollapsed">
      <mat-icon>expand_less</mat-icon>{{ 'farmer-insights.show-less' | translate }}
    </button>
  </div>
</agr-summary-card>

<ng-template #chartSummaryItem let-item>
  <div>
    <div class="flex--row text--small text--gray">
      <div class="flex__child--auto">
        {{ item.label | translate }}
      </div>
      <div class="float-right">
        <div>
          <strong *ngIf="item?.unit && item?.prefixUnit">{{ item.unit | translate }} </strong>
          <strong>{{ getKpiItemValue(item) }}</strong>
          <strong *ngIf="item?.unit && !item?.prefixUnit"> {{ item.unit | translate }}</strong>
        </div>
      </div>
    </div>
    <div>
      <agr-chart [options]="options[item.label]" [dataSource]="charts[item.label]"></agr-chart>
    </div>
  </div>
</ng-template>
